/* eslint-disable no-unused-vars */
import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FiUserPlus, FiFileText } from 'react-icons/fi';
import { blue, purple } from '@material-ui/core/colors';
import { PageContext } from '../context';
import {
  LPTitle,
  HighlightItem,
  HighlightItemContent,
  HighlightItemText,
  HighlightItemTitle,
} from '../../styles';
import Avatar from '../../../components/Avatar';
import {
  UserInfoWrapper,
  UserInfoHeader,
  UserInfoBody,
  Spacer,
} from './styles';

import StickyFooter from '../../../components/StickyFooter';

const UserInfoCheckin = ({ user }) => {
  const {
    firstName,
    lastName,
    phoneNumber,
    status,
    onCheckin,
  } = user;

  const { goToIndex } = useContext(PageContext);
  const handleCheckin = useCallback(onCheckin, [onCheckin]);
  const isCompleted = (status === 'CHECKED');

  return (
    <>
      <UserInfoWrapper>
        <UserInfoHeader>
          <Avatar
            huge
            user={{
              firstName,
              lastName,
              phoneNumber,
            }}
          />

          <Spacer />

          <LPTitle upcase center>
            <span className="thin">
              {firstName}
            </span>
            {lastName}
          </LPTitle>

          <LPTitle upcase center>
            {phoneNumber}
          </LPTitle>
        </UserInfoHeader>

        <UserInfoBody>
          <HighlightItem>
            <FiUserPlus className="icon_start" />

            <HighlightItemContent>
              <HighlightItemTitle>
                Guests
              </HighlightItemTitle>

              <HighlightItemText>
                {/* +2 guests */}
              </HighlightItemText>
            </HighlightItemContent>
          </HighlightItem>

          <HighlightItem>
            <FiFileText className="icon_start" />

            <HighlightItemContent>
              <HighlightItemTitle>
                Notes
              </HighlightItemTitle>

              <HighlightItemText>
                {/* I dont like cheese */}
              </HighlightItemText>
            </HighlightItemContent>
          </HighlightItem>
        </UserInfoBody>
      </UserInfoWrapper>

      <StickyFooter
        bgColor={isCompleted ? purple[600] : blue[600]}
        title={!isCompleted ? 'Check in' : 'Already Checked In'}
        handleOnclick={!isCompleted ? handleCheckin : goToIndex}
      />
    </>
  );
};

UserInfoCheckin.propTypes = {
  user: PropTypes.shape().isRequired,
};

export default UserInfoCheckin;
